module.exports = __webpack_public_path__ + "img/scenario-max.d2a08e8d.png";